import React from 'react'
import Marketplace from './Marketplace'

const Home = () => {
  return (
    <div className='home'>
        <Marketplace/>
    </div>
  )
}

export default Home